import React, { Component } from "react";
import styles from "./Title.module.css";
import goback from "../../images/租金宝返回键.png";
import { getStatusBarHeight, isAndroid } from "../../app/getUserInfoFromApp";
export default class TitlePhone extends Component {
  render() {
    const { goBack, rightContent, style, leftText } = this.props;
    const titleText = this.props.children;
    return (
      <>
        <div className={styles.topDiv} style={{ height: getStatusBarHeight(), backgroundColor: isAndroid() ? "#527AFB" : '#ffffff' }}></div>
        <div className={styles.header} style={{ top: getStatusBarHeight(), ...style }}>
         {
          localStorage.getItem('source') != '3' ?  <div className={styles.gobackDiv} onClick={goBack}>
              <img src={goback} className={styles.goback} alt="" />
            </div>:null
         }
        
          {leftText && <div className={styles.leftText}>{leftText}</div>}
          <h3>{titleText}</h3>
          {!rightContent ? (
            <span className={styles.span}></span>
          ) : (
            <div className={styles.headset}>
              {rightContent}
            </div>
          )}
        </div>
      </>
    );
  }
}